import { __awaiter, __generator, __read } from "tslib";
import { PermissionStatus, } from '@metaos/hub-sdk';
import { AppLinkDomains, } from '@office-start/app-host-types';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { launchMetaOSApp } from '@office-start/launcher-service';
import { fetchLocStrings } from '@office-start/loc-service';
import { logFeature } from '@office-start/telemetry-service';
import { logAppHostError } from '../utils/logAppHostError';
import { getAuthenticationService } from './AppHostAuthenticationService';
import { AppHostTelemetryService } from './AppHostTelemetryService';
import { createHubServices } from './createHubServices';
export var getHubServices = function (_a) {
    var appId = _a.appId, appHostSessionId = _a.appHostSessionId, frameContext = _a.frameContext, appbarConnectorService = _a.appbarConnectorService, dialogHandlers = _a.dialogHandlers, retryCallback = _a.retryCallback, setFrameInfoCallback = _a.setFrameInfoCallback, setShareLinkCallback = _a.setShareLinkCallback, showConsentDialogCallback = _a.showConsentDialogCallback, userId = _a.userId;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, authenticationService, officeComponentContext, locStrings, appLinkDomains, noOpFunction;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        getAuthenticationService(appId),
                        fetchOfficeComponentContext(),
                        fetchLocStrings(),
                    ])];
                case 1:
                    _b = __read.apply(void 0, [_c.sent(), 3]), authenticationService = _b[0], officeComponentContext = _b[1], locStrings = _b[2];
                    if (!officeComponentContext || !authenticationService || !locStrings) {
                        return [2 /*return*/, undefined];
                    }
                    appLinkDomains = AppLinkDomains;
                    noOpFunction = function () { return undefined; };
                    return [2 /*return*/, createHubServices({
                            appId: appId,
                            appLinkDomains: appLinkDomains,
                            appLinkRootPath: "m365apps" /* RoutePaths.M365Apps */,
                            appbarConnectorService: appbarConnectorService !== null && appbarConnectorService !== void 0 ? appbarConnectorService : new AppbarConnectorService(),
                            authenticationService: authenticationService,
                            capabilitiesFeatureGates: {
                                deepLinkServiceEnabled: true,
                                dialogServiceEnabled: true,
                            },
                            dialogHandlers: dialogHandlers,
                            locStrings: locStrings.metaOSHubResources,
                            navigateForwardCallback: function () {
                                var _a, _b;
                                logFeature({
                                    featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
                                    eventName: 'ReturnFocus',
                                    params: {
                                        AppId: appId,
                                        AppCapabilities: 'NavigateForward',
                                        DebugInfo: "focus set to search box",
                                        Service: 'NavigateForwardPageService',
                                    },
                                    area: 'MOSAppHost',
                                    subArea: 'AppHostPageService',
                                });
                                (_b = (_a = window.O365Shell) === null || _a === void 0 ? void 0 : _a.Search) === null || _b === void 0 ? void 0 : _b.FocusSearchBox();
                            },
                            navigateToAppCallback: function (params) {
                                var appDetails = {
                                    appId: params.appId,
                                    entityId: params.pageId,
                                    subPageId: params.subPageId ? params.subPageId : '',
                                };
                                var area = 'MOSAppHost';
                                logFeature({
                                    featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
                                    eventName: 'NavigateToApp',
                                    params: {
                                        AppId: params.appId,
                                        AppCapabilities: 'NavigateToApp',
                                        DebugInfo: 'NavigateToApp',
                                        Service: 'NavigateToAppPageService',
                                    },
                                    area: 'MOSAppHost',
                                    subArea: 'AppHostPageService',
                                });
                                launchMetaOSApp(appDetails, area).then(function (result) {
                                    if (!result.success) {
                                        logAppHostError('Navigate_App_Service_Error', result.message);
                                    }
                                });
                            },
                            officeComponentContext: officeComponentContext,
                            retryCallback: retryCallback !== null && retryCallback !== void 0 ? retryCallback : noOpFunction,
                            setFrameInfoCallback: setFrameInfoCallback !== null && setFrameInfoCallback !== void 0 ? setFrameInfoCallback : noOpFunction,
                            setShareLinkCallback: setShareLinkCallback !== null && setShareLinkCallback !== void 0 ? setShareLinkCallback : noOpFunction,
                            telemetryService: new AppHostTelemetryService(appHostSessionId, frameContext),
                            showConsentDialogCallback: showConsentDialogCallback !== null && showConsentDialogCallback !== void 0 ? showConsentDialogCallback : (function (_) {
                                console.log('NoOp consent callback');
                                return Promise.resolve(PermissionStatus.NeverAsked);
                            }),
                            userId: userId,
                        })];
            }
        });
    });
};
//# sourceMappingURL=getHubServices.js.map